import fetchData from '../api.js';


export const sendPrintJob = async (order_id, UserStore, type = 1) => {

    let postData = {}; 
    postData.action = 'crm_print_order';   
    postData.token = UserStore.data;
    postData.order_id = order_id;
    let response = await fetchData(postData);
    console.log(response);
    if (response.data) {

    }

    return true;    
};

export const silentPrint = (url,printer='') => {


    if (printer!='') {
        
        try {
            // Prepare the print job (plain text example)
            const config = qz.configs.create(printer , {
                density: 203,  // Check printer DPI; Brother TD-4550DN is usually 203 DPI
                scaleContent: true,
                paperWidth: 3.78, // 96 mm in inches
                paperHeight: 3.78,
                margins: { 
                    top: 0, 
                    right: 0, 
                    bottom: 0, 
                    left: 0 
                },
            });
            const data = [
                { 
                    type: "pdf", 
                    format: "url", 
                    data: url ,
                    // options: {
                    //     density: 203,  // Check printer DPI; Brother TD-4550DN is usually 203 DPI
                    //     scaleContent: true,
                    //     paperWidth: 3.78, // 96 mm in inches
                    //     paperHeight: 3.78,
                    //     margins: { top: 0, right: 0, bottom: 0, left: 0 },
                    // }
                }
            ];

            qz.print(config, data)
                .then(() => console.log("Print job successful"))
                .catch(err => console.error("Print failed", err));
                //alert("Print job sent successfully!");
            return;
        } catch (error) {
            console.error("Failed to print:", error);
            alert("Error sending print job: " + error.message);
        }

    } else {

        // Fetch content from the URL
        fetch(url)
        .then(response => response.text())
        .then(data => {        

            // Create an iframe
            var iframe = document.createElement('iframe');
            iframe.style.position = 'absolute';
            iframe.style.width = '0px';
            iframe.style.height = '0px';
            iframe.style.border = 'none';
            
            // Append iframe to the body
            document.body.appendChild(iframe);
            
            // Access iframe's document and write content into it
            var iframeDoc = iframe.contentWindow.document;
            iframeDoc.open();
            iframeDoc.write(data);
            iframeDoc.close();
            
            // Wait for iframe to load and then print
            iframe.onload = function() {
                iframe.contentWindow.print();
            };
        })
        .catch(error => console.error('Error fetching content:', error));

    }


    return

    // url = url.replace(/http:/g, 'https:');
    // console.log('replace http to https',url)
   
    var iframe = document.createElement('iframe');
    iframe.style.position = 'absolute';
    iframe.style.width = '0px';
    iframe.style.height = '0px';
    iframe.style.border = 'none';
    iframe.src = url;
    iframe.setAttribute('sandbox', 'allow-scripts allow-popups');

    
    // Append iframe to body
    document.body.appendChild(iframe);
    
    // Once iframe is loaded, trigger the print function
    iframe.onload = function () {
        iframe.contentWindow.print();
        // Optionally, remove the iframe after printing
        document.body.removeChild(iframe);
    };     
      

}